import styled from 'styled-components';

export const CarouselWrapper = styled.div.attrs(() => ({
    className: String('ap-carousel-wrapper')
}))`
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
`;
